<template>
  <v-card ref="BaseCard" rounded v-bind="$attrs" :class="cardClasses">
    <v-card-title
      ref="BaseCardTitle"
      :class="headerClasses"
      :style="`top: ${top}px`"
    >
      <slot name="header">
        <div class="w-100 d-flex flex-row justify-content-between">
          <div>{{ title }}</div>
        </div>
      </slot>
    </v-card-title>
    <v-divider> </v-divider>
    <v-card-text :class="bodyClasses" :style="bodyStyles">
      <slot></slot>
    </v-card-text>

    <v-card-actions :class="footerClasses" v-if="$slots.footer">
      <slot name="footer"></slot>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "base-card",
  props: {
    title: String,
    bodyClasses: {
      type: [String, Object, Array],
      description: "Card body css classes",
    },
    bodyStyles: {
      type: [String, Object, Array],
      description: "Card body css styles",
    },
    cardClasses: {
      type: [String, Object, Array],
      description: "Card  css classes",
    },
    headerClasses: {
      type: [String, Object, Array],
      description: "Card header css classes",
    },
    footerClasses: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    sticky: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initialTop: 0,
      top: 0,
    };
  },
  created() {
    if (this.sticky) {
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  destroyed() {
    if (this.sticky) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
  mounted() {
    this.initialTop = this.$refs.BaseCardTitle.getBoundingClientRect().top;
    const tabs = document.querySelector(".tags-view-container");
    const mobileHeader = document.querySelector(".header-mobile");
    const header = document.querySelector(".header");
    if (this.$vuetify.breakpoint.width >= 996) {
      if (tabs) {
        this.top =
          header.getBoundingClientRect().height +
          tabs.getBoundingClientRect().height;
      } else {
        this.top = document
          .querySelector(".header")
          .getBoundingClientRect().height;
      }
    } else {
      if (tabs) {
        this.top =
          mobileHeader.getBoundingClientRect().height +
          tabs.getBoundingClientRect().height;
      } else {
        this.top = mobileHeader.getBoundingClientRect().height;
      }
    }
  },
  methods: {
    handleScroll() {
      let scrollY = Math.round(window.scrollY);
      if(scrollY == 0) {
        this.initialTop = this.$refs.BaseCardTitle.getBoundingClientRect().top;
      }
      if (scrollY > this.initialTop + 20) {
        this.$refs.BaseCardTitle.classList.add("sticky-header");
      } else {
        this.$refs.BaseCardTitle.classList.remove("sticky-header");
      }
    },
  },
};
</script>
<style scoped>
.sticky-header {
  position: sticky;
  background: white;
  z-index: 94;
  box-shadow: 0 4px 3px 0 rgb(0 0 0 / 12%), 0 1px 3px 0 rgb(0 0 0 / 4%);
  transition: all 0.3s ease-in-out;
}
.v-card__title.sticky-header {
  margin-right: -12px;
  margin-left: -12px;
}
</style>
